import { useLingui } from '@lingui/react';
import { Box, Group, Stack, Text } from '@mantine/core';
import EventItem, { EventItemMultiple } from './EventItem';
import { ThemeText } from '../../Atoms/ThemeText';
import { useContext } from 'react';
import { EventsContext } from '../../Service/Context/EventsContext';
import { getEventDateGroupKey, groupEventDates } from './groupEventDates';

const EventsMonthPane = ({ month, year, eventSums, eventDates }) => {
  const { i18n } = useLingui();
  const { filter } = useContext(EventsContext) ?? {};
  const { agencyModeActive } = filter ?? { agencyModeActive: false };
  const { length } = eventDates;
  const monthTitle = month === 1 && year === 1970 ? 'Ohne Datum' : `${i18n._(`month.${month}`)} ${year}`;

  if (length === 0) {
    return null;
  }

  const regularDateLength = new Set(
    eventDates.filter((e) => e.type === 'REGULAR_DATE').map((eventDate) => eventDate.eventId),
  ).size;
  const appointmentsLength = eventDates.filter((e) => e.type === 'APPOINTMENT').length;

  const groupedEvents = groupEventDates(eventDates, { agencyModeActive, sortGroupsBy: 'start' });

  // Build components
  const eventsOfMonth = groupedEvents.map((dates) =>
    dates.length === 1 ? (
      <EventItem key={dates[0].id} bookingEventDate={dates[0]} />
    ) : (
      <EventItemMultiple key={getEventDateGroupKey(dates)} bookingEventDates={dates} />
    ),
  );

  return (
    <div className="events-month-indent">
      <Box
        p="md"
        mt={15}
        sx={(theme) => ({
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[0],
          borderRadius: 10,
        })}
      >
        <Group>
          <ThemeText size="lg" weight="bold">{monthTitle}</ThemeText>
          {regularDateLength > 0 && <Text size="xs" color="dimmed">{`${regularDateLength} Events`}</Text>}
          {!agencyModeActive && appointmentsLength > 0 && (
            <Text size="xs" color="dimmed">{`${appointmentsLength} Termine`}</Text>
          )}
        </Group>
      </Box>
      <Stack mt="sm">{eventsOfMonth}</Stack>
    </div>
  );
};

export default EventsMonthPane;
